import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { SidenavState } from '../reducers/sidenav.reducer';
import * as selectors from '../selectors/sidenav.selectors';

@Injectable()
export class SidenavFacadeService extends FacadeService {
  constructor(public override store: Store<SidenavState>) {
    super(store);
  }
  // OBSERVABLES

  sidenavStatus$ = this.storeSelect(selectors.getSidenavStatus);
  assignCheckbook$ = this.storeSelect(selectors.getAssignCheckbook);
  renderAssignCheckbook$ = this.storeSelect(selectors.getRenderAssignCheckbook);
  renderCheckbookGroupTemplate$ = this.storeSelect(selectors.getRenderCheckbookGroupTemplate);

  // OBSERVABLE'S VALUES

  get sidenavStatus() {
    return this.storeSnapshot(this.sidenavStatus$);
  }

  get assignCheckbook() {
    return this.storeSnapshot(this.assignCheckbook$);
  }

  get renderAssignCheckbook() {
    return this.storeSnapshot(this.renderAssignCheckbook$);
  }

  get renderCheckbookGroupTemplate() {
    return this.storeSnapshot(this.renderCheckbookGroupTemplate$);
  }
}
